<template>
  <component :is="component"></component>
</template>

<script>
import IconChecked from '@/components/UI/icons/IconChecked';
import IconUnchecked from '@/components/UI/icons/IconUnchecked';

export default {
  name: 'VIcon',
  components: {
    IconChecked,
  },

  props: {
    icon: String,
  },

  computed: {
    component() {
      switch (this.icon) {
        case 'checked': return IconChecked;
        case 'unchecked': return IconUnchecked;
        default: return IconChecked;
      }
    }
  },
}
</script>
